import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlBuilder } from '../core';
import { findSiteUrlParam, findStudyUrlParam } from '../shared/route-helpers';
import { InvestigatorSitesStorage } from './investigator-sites-storage';
import { Site } from './site';

@Injectable()
export class SelectedSiteResolver implements Resolve<Site | boolean> {

    constructor(private sitesStorage: InvestigatorSitesStorage, private router: Router, private urlBuilder: UrlBuilder) { }

    public resolve(route: ActivatedRouteSnapshot): Observable<Site | boolean> {
        const siteUrlParam = findSiteUrlParam(route);
        const studyUrlParam = findStudyUrlParam(route);

        const sitesObservable = this.sitesStorage.loadSites();

        return sitesObservable
            .pipe(
                map<Site[], Site | boolean>(sites => {

                    if (sites.length === 0) {
                        this.urlBuilder.esa().navigate();
                        return false;
                    }

                    const selectedSite = sites.find(site => site.siteUrlParameter === siteUrlParam &&
                        site.study.studyUrlParameter === studyUrlParam);
                    if (!selectedSite) {
                        this.router.navigateByUrl(
                            '/home'); // navigate to a fake link that redirects to '/' or rendering will be cancelled (https://github.com/angular/angular/issues/16211)
                        return false;
                    }

                    return selectedSite;
                }));
    }
}